/**
 * Trading Arrival's list.
 *
 * A static segment, so it takes precedence over `$form` and the generic route needs no change. The
 * LIST keeps `ArrivalListPage`: it is a table of documents, not a form — the same columns, filters
 * and print column every arrival list shows, and nothing about it is Trading-specific.
 */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ArrivalListPage } from "@/features/arrival/components/list/arrival-list-page";
import { FORM_PENDING } from "@/features/arrival/forms";
import { useAuth } from "@/features/auth/store";

const search = z.object({
  tab: z.string().optional(),
  q: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  page: z.number().int().min(1).default(1),
});

export const Route = createFileRoute("/_app/arrivals/trading/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <ArrivalListPage
      title="Trading Arrival"
      formCode="arrival_trading"
      slug="trading"
      pendingView={FORM_PENDING.trading}
      search={{ ...s, tab: s.tab ?? "draft" }}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
